<div class="input__email">
    <input 
        [value]="control.value" 
        [placeholder]="placeholder()" 
        type="email" 
        (input)="onInput($event)"
        maxlength="30"
        [formControl]="control"
    />
    <div class="message">{{control.errors | errorMessage | translate}}</div>
</div>